import { render, staticRenderFns } from "./PDDAllianceAuthorization.vue?vue&type=template&id=ea9028ce"
import script from "./PDDAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./PDDAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea9028ce')) {
      api.createRecord('ea9028ce', component.options)
    } else {
      api.reload('ea9028ce', component.options)
    }
    module.hot.accept("./PDDAllianceAuthorization.vue?vue&type=template&id=ea9028ce", function () {
      api.rerender('ea9028ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/PDDAllianceAuthorization.vue"
export default component.exports